<template>
  <div class="text-center">
    <h1
      class="
       text-2xl
       tracking-tight
       font-black
     text-gray-900
       sm:text-3xl
      "
    >
      <span class="block">Success,</span>
      <span class="block text-mygrad">they're yours to keep!</span>
    </h1>
    <p
      class="
         mt-3
         max-w-md
         mx-auto
         text-sm text-gray-700
         sm:text-base
         md:mt-5 md:max-w-3xl
      "
    >
      Thank you for purchasing your special moment!
    </p>
    <p
      class="
       mt-3
         max-w-md
         mx-auto
         text-sm text-gray-700
         sm:text-base
         md:mt-5 md:max-w-3xl
      "
    >
      Physical copies can be purchased at the stand using this code: <span><b>{{ nanoID }}</b></span>
    </p>
    <p
      v-if="email"
      class="
        mt-3
         max-w-md
         mx-auto
         text-sm text-gray-700
         sm:text-base
         md:mt-5 md:max-w-3xl
      "
    >
      Digital photos will be sent to {{ email }} for you to download
    </p>
    <p
      v-else
      class="
        mt-3
         max-w-md
         mx-auto
         text-sm text-gray-700
         sm:text-base
         md:mt-5 md:max-w-3xl
      "
    >
      Digital photos will be sent to the email address used at checkout.
    </p>
  </div>
</template>

<script>
export default {
  name: 'SnapshotSuccessMessage',
  props: {
      email: String,
      nanoID: String,
  }
};
</script>
